import { view } from "@/mega-ui/helpers/function"
import { checkUserRoleGuard, optimizeSubscriptionGuard } from "@/helpers/routerHelpers"

export const subscription = {
    path: '/subscription',
    name: 'subscription',
    children: [
        {
            path: 'main',
            name: 'subscription-main',
            meta: {
                withAuth: true,
                withProducts: true,
                withPromotion: true
            },
            component: () => view('subscription/SubscriptionMainView')
        },
        {
            path: 'optimize',
            name: 'subscription-optimize',
            beforeEnter: [ checkUserRoleGuard, optimizeSubscriptionGuard ],
            meta: {
                withAuth: true,
                withProducts: true,
                withPromotion: true
            },
            component: () => view('subscription/OptimizeSubscriptionView')
        },
        {
            path: 'order-summary',
            name: 'order-summary',
            beforeEnter: [ checkUserRoleGuard, optimizeSubscriptionGuard ],
            meta: {
                withAuth: true,
                withProducts: true
            },
            component: () => view('subscription/OrderSummaryView')
        },
    ]
}